<template>
    <div class="review">
        <div v-show="review_sent">
            <review-sent :review_state="review_state" />
        </div>

        <div v-show="!review_sent" v-if="!loading_quote">

            <div class="panel review--heading" primary noradius>
                <div class="title" v-html="quote.details.title"></div>
                <div class="subtitle">
                    <div>
                        <p class="mb-0">Proposta di viaggio per <strong>{{ request.request_customer.firstname }} {{ request.request_customer.lastname }}</strong></p>
                        <p class="mb-0" v-if="quote.details.review_expire_at"> valida fino al {{ quote.details.review_expire_at | moment("DD-MM-YYYY") }}</p>
                        <p>Richiesta numero <strong>{{ quote.request_id }}</strong> del <strong>{{ request.request_customer.request_date }}</strong></p>
                        <p v-if="quote.details.departure && quote.details.departure">
                          Inizio: <strong>{{ quote.details.departure | moment("DD-MM-YYYY") }}</strong> - Fine: <strong>{{ quote.details.return | moment("DD-MM-YYYY")}}</strong>
                        </p>
                        <p class="mb-0">
                            Scopri qui sotto l'elenco, la descrizione ed il prezzo dei servizi inclusi nella proposta. Se desideri modifiche o desideri ottenere le istruzioni su come prenotare questsa proposta con il tuo welfare aziendale clicca in fondo alla pagina.
                            <strong>
                                I prezzi e le disponibilità di questa proposta sono soggetti a conferma.
                            </strong>
                            Le richieste che invii dopo le 17 verranno lavorate il giorno successivo.
                        </p>
                    </div>
                </div>
            </div>

            <review-agent-notes v-if="quote.details.agent_notes && quote.details.agent_notes != ''" :agent_notes="quote.details.agent_notes" />
            
            <!-- review block -->
            <div class="review--block" :id="'review-'+review_step.type" v-for="(review_step) in review_steps" v-bind:key="review_step.service_index">

                <review-overnight
                    v-if="review_step.type == 'overnight'"
                    :service="quote.services[review_step.service_index]"
                    :opened="review_steps[review_step.service_index].opened"
                    :details="quote.details"
                    @toggled="(value) => toggle_step(review_step.service_index,value)"
                    @completed="(value) => mark_step_as_completed(review_step.service_index, value)"
                />

                <review-package
                    v-if="review_step.type == 'package'"
                    :service="quote.services[review_step.service_index]"
                    :opened="review_steps[review_step.service_index].opened"
                    :details="quote.details"
                    @toggled="(value) => toggle_step(review_step.service_index,value)"
                    @completed="(value) => mark_step_as_completed(review_step.service_index, value)"
                />

                <review-flight
                    v-if="review_step.type == 'flight'"
                    :service="quote.services[review_step.service_index]"
                    :opened="review_steps[review_step.service_index].opened"
                    :quote_dictionaries="quote.dictionaries"
                    :details="quote.details"
                    @toggled="(value) => toggle_step(review_step.service_index,value)"
                    @completed="(value) => mark_step_as_completed(review_step.service_index, value)"
                />

                <review-transfer
                    v-if="review_step.type == 'transfer'"
                    :service="quote.services[review_step.service_index]"
                    :opened="review_steps[review_step.service_index].opened"
                    @toggled="(value) => toggle_step(review_step.service_index,value)"
                    @completed="(value) => mark_step_as_completed(review_step.service_index, value)"
                />

                <review-generic
                    v-if="review_step.type == 'generic'"
                    :service="quote.services[review_step.service_index]"
                    :opened="review_steps[review_step.service_index].opened"
                    @toggled="(value) => toggle_step(review_step.service_index,value)"
                    @completed="(value) => mark_step_as_completed(review_step.service_index, value)"
                />

                <review-insurance
                    v-if="review_step.type == 'insurance'"
                    :service="quote.services[review_step.service_index]"
                    :opened="review_steps[review_step.service_index].opened"
                    @toggled="(value) => toggle_step(review_step.service_index,value)"
                    @completed="(value) => mark_step_as_completed(review_step.service_index, value)"
                />

                <review-resume
                    v-if="review_step.type == 'resume' && !updating_resume"
                    :review_steps="review_steps"
                    :opened="true/*review_steps[review_step.service_index].opened*/"
                    :dictionaries="quote.dictionaries"
                    :review_state="review_state"
                    @toggled="(value) => toggle_step(review_step.service_index,value)"
                    @send_to_api="(payload) => {
                        prepare_api_parameters(payload)
                        check_pax_or_proceed()
                    }"
                />
            </div>

            <b-modal id="info-pax-modal" title="Inserisci i dati dei partecipanti" size="xl" hide-footer>
                <info-pax
                    @completed="(pax) => {
                        if(!this.quote.pax) this.quote.pax = {}
                        this.quote.pax = pax
                        if(!this.api_parameters.quote.pax) this.api_parameters.quote.pax = {}
                        this.api_parameters.quote.pax = pax
                        this.post_review_to_api()
                    }"
                    :occupancy="(quote.details.occupancy ? quote.details.occupancy : { adults: 1 })"
                    :icons="true"
                    :text_top="'Inserisci i dati con cura perché saranno utilizzati per opzionare i servizi richiesti.'"
                    :text_middle="'Non c\'è nessun impegno: sarai libero di abbandonare il processo di prenotazione in ogni momento.'"
                    :text_down="'Premendo il tasto qui sotto la soluzione verrà pubblicata nello shop e potrai prenotarla col credito welfare. Riceverai un\'email di notifica non appena il prodotto sarà online'"
                    :text_cta="'Richiedi la pubblicazione'"
                />
            </b-modal>
        </div>


    </div>  
</template>

<script>
    //import Bwi from '@/components/atoms/button-with-icon'
    import InfoPax from '@/components/blocks/info-pax'
    import ReviewOvernight from '@/components/review/review-overnight'
    import ReviewFlight from '@/components/review/review-flight'
    import ReviewTransfer from '@/components/review/review-transfer'
    import ReviewGeneric from '@/components/review/review-generic'
    import ReviewInsurance from '@/components/review/review-insurance'
    import ReviewAgentNotes from '@/components/review/review-agent-notes'
    import ReviewPackage from '@/components/review/review-package'
    //...
    import ReviewResume from '@/components/review/review-resume'
    import ReviewSent from '@/components/review/review-sent'
    import { bedding, airplane, bus, shield, camera, checked, info } from '@/components/svg/common'
    import { chevron_right } from '@/components/svg/chevrons'
    import { post_review } from '@/api'
    import { parse_flight_offers_date, custom_event } from '@/utilities'

    export default {
        name: 'review',
        components: {
            'info-pax': InfoPax,
            'review-overnight': ReviewOvernight,
            'review-flight': ReviewFlight,
            'review-transfer': ReviewTransfer,
            'review-generic': ReviewGeneric,
            'review-insurance': ReviewInsurance,
            'review-agent-notes': ReviewAgentNotes,
            'review-resume': ReviewResume,
            'review-sent': ReviewSent,
            //'button-with-icon': Bwi,
            //'switcher': CustomSwitch,
            'review-package': ReviewPackage,
        },
        props:{
          request_id: String,
          secret: String,
        },
        data() {
            return {
                updating_resume: true,
                review_sent: false,
                //overnight_selected: -1,
                //flight_selected: -1,
                //transfer_selected: -1,
                //generic_selected: -1,
                //insurance_selected: -1,
                loading_quote: true,
                review_steps: [
                    {
                        type: 'resume',
                        opened: false,
                        completed: false,
                    },
                ],
                api_parameters: {},
                review_state: 'declined',
            }
        },
        computed: {
            /*
            loading: {
                get() {
                    return this.$store.state.loading
                },
            },
            */
            quote: {
                get() {
                    return this.$store.state.quote
                },
                set(quote) {
                    this.$store.commit('set_quote', { quote: quote })
                }
            },
            request: {
                get() {
                    return this.$store.state.request
                },
                set(request) {
                    this.$store.commit('set_request', { request: request })
                }
            },            
        },
        created()
        {
            this.bedding = bedding
            this.airplane = airplane
            this.bus = bus
            this.shield = shield
            this.camera = camera
            this.checked = checked
            this.info = info
            this.chevron_right = chevron_right
            this.parse_flight_offers_date = parse_flight_offers_date
        },
        mounted() {
            let steps = []
            this.quote.services.forEach((service,index) => {
                steps.push({
                    type: service.type,
                    //service_index: service.service_index,
                    service_index: index, // FIXME
                    opened: (index == 0),
                    completed: false   
                })
            })
            this.review_steps[0].service_index = steps.length
            this.review_steps = [
                ...steps,
                ...this.review_steps
            ]
            this.loading_quote = false
        },
        methods:{
            filter_step_by_service_index(service_index)
            {
                for(let i=0; i<this.review_steps.length; i++)
                {
                    if ( this.review_steps[i].service_index == service_index )
                    {
                        return {
                            step: this.review_steps[i],
                            index: i,
                        }
                    }
                }
            },
            toggle_step(service_index, value)
            {
                let step = this.filter_step_by_service_index(service_index).step
                if(step.opened)
                {
                    this.mark_step_as_completed(service_index, value)
                }
                else
                {
                    this.mark_step_as_opened(service_index)
                }                
            },
            mark_step_as_opened(service_index)
            {
                let filtered_step = this.filter_step_by_service_index(service_index),
                    step = filtered_step.step
                    //index = filtered_step.index

                // mark this step as NOT completed AND opened
                step.opened = true
                step.completed = false

                /*
                // mark next review_steps as NOT completed and NOT opened
                if( this.review_steps.length >= (index+1))
                {
                    for(let i=index+1; i<this.review_steps.length; i++)
                    {
                        this.review_steps[i].completed = false
                        this.review_steps[i].opened = false
                    }
                }
                */
            },
            mark_step_as_completed(service_index, value)
            {
                this.updating_resume = true

                let filtered_step = this.filter_step_by_service_index(service_index),
                    step = filtered_step.step
                    //index = filtered_step.index

                step.completed = true
                step.opened = false
                step.selected = parseInt(value.selected)

                this.$nextTick(function(){
                    this.updating_resume = false
                })

                /*
                if( this.review_steps.length >= index)
                {
                    this.review_steps[index+1].opened = true
                    this.review_steps[index+1].completed = false
                }
                */
            },
            prepare_api_parameters(payload)
            {
                this.api_parameters = {}

                let reviewed_quote = Object.assign({}, this.quote)
                this.quote.services.forEach( (service,index) => {
                    reviewed_quote.services[index] = service
                })

                let parameters = {
                    request_id: this.request_id,
                    secret: this.secret,
                    quote: reviewed_quote
                }

                if( payload.user_changes_request )
                {
                    parameters.user_changes_request = payload.user_changes_request
                }

                if( payload.user_reject_note )
                {
                    parameters.user_reject_note = payload.user_reject_note
                }

                this.api_parameters = parameters
            },
            check_pax_or_proceed()
            {
                // se ho chiesto una modifica vado avanti
                if(this.api_parameters.user_changes_request)
                {
                    this.post_review_to_api()
                    return
                }

                // se ho rifiutato la proposta vado avanti
                if(this.api_parameters.user_reject_note)
                {
                    this.post_review_to_api()
                    return
                }

                // se ho accettato i pax vanno chiesti sempre
                this.$bvModal.show('info-pax-modal')
            },
            post_review_to_api()
            {
                post_review(this.api_parameters)
                    .then((response) => {
                        this.review_sent = true
                        this.review_state = response.review_state
                        this.$bvModal.hide('info-pax-modal')
                        custom_event('reviewed', response.request_id)
                        custom_event('review_' + response.review_state, response.request_id)
                    })
            },
        },
    }
</script>

<style lang="scss">
    .review
    {
        margin-bottom: 100px;
        &--block
        {
            margin-bottom: $grid-gutter-width/4;
            font-size: 14px;
            &--header
            {
                cursor:pointer;
                transition:$transition-fade;
                width:100%;
                display: flex;
                align-items: center;
                background:$tertiary;
                color:$white;
                padding:$grid-gutter-width/4 $grid-gutter-width/2;
                margin-bottom:$grid-gutter-width/4;
                &--icon
                {
                    width:40px;
                    text-align: left;
                    svg
                    {
                        max-width: 20px;
                        max-height: 24px;
                    }
                }
                &--title
                {
                    font-weight: bold;
                    font-size: 16px;
                    flex:1;
                    display: flex;
                    flex-direction: column;
                }
                &--checked
                {
                    width:40px;
                    text-align: right;
                }
                &:hover
                {
                    opacity:0.9;
                }
                &--subtitle
                {
                    font-weight: 600;
                    font-size: 14px;
                }
            }
            &--body
            {
                @extend .panel !optional;
                border-radius: 0;
                &--header
                {
                    @extend .panel--header !optional;
                    &--title
                    {
                        @extend .panel--header--title !optional;
                    }                    
                    &--icon
                    {
                        @extend .panel--header--icon !optional;
                    }                    
                    &--subtitle
                    {
                        @extend .panel--header--subtitle !optional;
                    }                    
                }
                &--content
                {
                    @extend .panel--content !optional;
                }
            }
            &--footer
            {
                @extend .panel--footer !optional;
                text-align: center;
                margin-bottom:$grid-gutter-width/2;
                .bwi
                {
                    max-width: 400px;
                    margin:0 auto;
                }
            }
        }
        &--option
        {
            display:flex;
            align-items: center;
            &:not(:last-child)
            {
                margin-bottom:$grid-gutter-width/4;
            }
            &--content
            {
                font-size:14px;
                flex:1;
                &:not(:last-child)
                {
                    margin-bottom:$grid-gutter-width/4;
                }
            }
            &--control
            {
                width:80px;
                text-align: center;
                cursor:pointer;
            }

            &--title
            {
                font-size: 18px;
                font-weight: bold;
                color:$primary;
            }
            &--dates
            {
                display: flex;
                flex-wrap: wrap;
                &>div:first-child
                {
                    &:after
                    {
                        content:"|";
                        margin:0 0.75rem;
                    }
                }
            }

        }
        &--title--small
        {
            font-size: 14px;
            font-weight: bold;
            color: $primary;
        }
        &--heading
        {
            @extend .review--block !optional;
        }        
    }
</style>